import React from 'react';
import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from 'utils/BackgroundJobs';
import { getMutationProps, getRangeMutationProps } from './DocumentAction';
import { onDocumentPrintComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import StockAdjustmentLabel from '../../graphql/entities/product/StockAdjustmentLabel';

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    StockAdjustmentLabel.generate,
    getMutationProps(state, props, variables, 'stockAdjustment'),
    props,
    returnUrl,
    'Generate Stock Adjustment Label',
    (job) => onDocumentPrintComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    StockAdjustmentLabel.generateRange,
    getRangeMutationProps(state, props, variables, 'stockAdjustments'),
    props,
    returnUrl,
    'Generate Stock Adjustment Labels',
    (job) => onDocumentPrintComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

export function reprintRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;

  createBackgroundJob(
    StockAdjustmentLabel.reprint,
    getRangeMutationProps(state, props, variables, 'labels'),
    props,
    returnUrl,
    'Generate Stock Adjustment Labels',
    (job) => onDocumentPrintComplete(state, props, job)
  );
}
